//export const BASE_URL = 'https://v-network-devat.herokuapp.com'
export const BASE_URL = process.env.REACT_APP_API_URL